import { useNavigate } from 'react-router-dom';
import { footerQuickLinks, footerConsultancyLinks } from '@/mocks/homeData';

export default function Footer() {
  const navigate = useNavigate();

  const handleLinkClick = (href: string) => {
    if (href.startsWith('/#')) {
      const id = href.replace('/#', '#');
      const el = document.querySelector(id);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    } else if (href.startsWith('#')) {
      const el = document.querySelector(href);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate(href);
    }
  };

  return (
    <footer className="bg-navy-700 text-white">
      <div className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">
            {/* Column 1: Brand */}
            <div className="sm:col-span-2 lg:col-span-1">
              <img src="/assets/logo2.png" alt="EzyAbroad" className="h-10 w-auto" />
              <p className="mt-4 text-sm text-white/50 leading-relaxed">
                The day-to-day management portal for education consultancies — students, leads, applications, and team, all in one place. Powered by AI.
              </p>
              <p className="mt-6 text-xs text-white/35">Official social channels coming soon.</p>
            </div>

            {/* Column 2: Quick Links */}
            <div>
              <h4 className="text-sm font-semibold uppercase tracking-wide mb-4">Quick Links</h4>
              <ul className="space-y-2.5">
                {footerQuickLinks.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick(link.href);
                      }}
                      className="text-sm text-white/60 hover:text-gold-400 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Column 3: For Consultancies */}
            <div>
              <h4 className="text-sm font-semibold uppercase tracking-wide mb-4">For Consultancies</h4>
              <ul className="space-y-2.5">
                {footerConsultancyLinks.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick(link.href);
                      }}
                      className="text-sm text-white/60 hover:text-gold-400 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Column 4: Download App */}
            <div>
              <h4 className="text-sm font-semibold uppercase tracking-wide mb-4">Get the EzyAbroad App</h4>
              <p className="text-sm text-white/50 mb-4">The student mobile app is coming later.</p>
              <div className="space-y-3">
                <div className="inline-flex items-center gap-2 px-4 py-2.5 bg-white/5 rounded-lg text-white/50" aria-disabled="true">
                  <i className="ri-apple-fill text-lg" />
                  <div className="text-left">
                    <div className="text-[9px] leading-none opacity-70">Planned for</div>
                    <div className="text-xs font-semibold leading-tight">App Store</div>
                  </div>
                </div>
                <div className="inline-flex items-center gap-2 px-4 py-2.5 bg-white/5 rounded-lg text-white/50" aria-disabled="true">
                  <i className="ri-google-play-fill text-lg" />
                  <div className="text-left">
                    <div className="text-[9px] leading-none opacity-70">Planned for</div>
                    <div className="text-xs font-semibold leading-tight">Google Play</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="w-full px-4 md:px-8 lg:px-12 py-5">
          <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-white/40">
              &copy; 2025 EzyAbroad Technologies Pvt. Ltd. All rights reserved.
            </p>
            <div className="flex items-center gap-4">
              <a href="/privacy" onClick={(e) => { e.preventDefault(); navigate('/privacy'); }} className="text-xs text-white/40 hover:text-white/70 transition-colors cursor-pointer">Privacy Policy</a>
              <span className="text-white/20">|</span>
              <a href="/terms" onClick={(e) => { e.preventDefault(); navigate('/terms'); }} className="text-xs text-white/40 hover:text-white/70 transition-colors cursor-pointer">Terms of Service</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
